import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { organizationAdminsApi } from '../../api/lib/organization-admins';
import { organizationAdminsKeys } from '../../api/query-keys/organization-admins';

import { ApiError } from '@/types/interfaces/api-error';

export const useRemoveAdmin = (onSuccess?: () => void) => {
  const { t } = useTranslation(['organizationAdmins']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => organizationAdminsApi.removeAdminFromOrganization(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: organizationAdminsKeys.lists() });
      toast.success(t('organizationAdmins:removeSuccess'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
